import { render, staticRenderFns } from "./EmptyNumbers.vue?vue&type=template&id=4a2218bf&"
import script from "./EmptyNumbers.vue?vue&type=script&lang=js&"
export * from "./EmptyNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports